const isDomainNameUsed = async (slug, errorHandler, shouldRedirect = false) => {
    if (slug.length < 3) {
        return false;
    }

    const response = await fetch(`${APP_DOMAIN}/api/check-zone-name/${slug}/`, {
        method: "GET",
        credentials: "include",
    });

    if (response.status === 429) {
        let error = 'Too many requests from this IP address. Try again later.';
        errorHandler(error);
        throw new Error(error);
    }

    if (!response.ok) {
        let error = 'An unknown error occurred. If the problem persists, please contact support.';
        errorHandler(error);
        throw new Error(error);
    }

    const result = await response.json();

    if (result.zone_is_disabled && shouldRedirect) {
        window.location = result.url;
        return;
    }

    return result.zone_slug_is_used
}

export default isDomainNameUsed;
